import { Component } from '@angular/core';

@Component({
		templateUrl: './notfound.component.html',
})
export class NotFoundComponent {
		public pageTitle = 'Invalid Payment Options';
}
